import React from 'react';
import Highlighter from './Highlighter';
import TabularDataLink from './TabularDataLink';
import { Xrefs } from './Xref';

interface TableData {
    table_title: string
    table_header: Array<string>
    table_rows: Array<TableRow>
}

interface TableRow {
    breadcrumbs: string
    codes: Array<string>
    value: string
    xrefs: Array<string>
}

const IndexTable = (props: { tableData: TableData, searchTerm: string, id: string }) => {

    const tableHeaders = props.tableData ? props.tableData.table_header.map((header: string, index: number) => {
        if (index === 0) {
            return <th key={header} style={{"width": "50%"}}>{header}</th>
        } else {
            return <th key={header}>{header}</th>
        }
    }) : []

    const tableRows = props.tableData ? props.tableData.table_rows.map((row: TableRow, index: number) => {
        const dataColumns = row.codes.map((code, index) => {
            return (
                <td key={`${row.value}${code}${index}`}>
                    <TabularDataLink linkTo={code} />
                </td>
            )
        })

        const firstColumnData = function () {
            if (row.breadcrumbs) {
                return (
                    <td>
                        <span className="text-muted font-weight-normal"><Highlighter value={row.breadcrumbs} searchTerm={props.searchTerm} /></span>
                        <span><Highlighter value={row.value.replace(row.breadcrumbs, '')} searchTerm={props.searchTerm} /></span>
                        { row.xrefs[0] ? <Xrefs starter={row.xrefs[0][0]} linkTo={row.xrefs[0][1]} /> : ''}
                    </td>
                )
            } else {
                return (
                    <td>
                        <span><Highlighter value={row.value} searchTerm={props.searchTerm} /></span>
                        { row.xrefs[0] ? <Xrefs starter={row.xrefs[0][0]} linkTo={row.xrefs[0][1]} /> : ''}
                    </td>
                )
            }
        }

        return (
            <tr key={`drugTableRow-${index}`} className="result-success strong">
                { firstColumnData() }
                { dataColumns }
            </tr>
        )
    }) : []

    if (!props.tableData) return null;
    return (
        <div id={props.id} className="page-anchor">
            <div id={props.tableData.table_title} className="section-divider">{props.tableData.table_title}</div>
            <table className="table table-condensed table-striped">
                <thead>
                    <tr>
                        {tableHeaders}
                    </tr>
                </thead>
                <tbody>
                    {tableRows}
                </tbody>
            </table>
        </div>
    )

}

export default IndexTable;
